import { AvailableLanguages, LanguageCode } from "./language"

export class CustomerInfo {
	defaultFormats: string = "en-GB"
	defaultLanguage: LanguageCode = "en-GB"
	availableLanguages: AvailableLanguages = {
		"en-GB": "English (UK)"
	}
	version: string = ""
	skinId: string = ""
	skin: Skin = null
	skinValue: any | null = null
	isDebugMode: boolean = true
	exitUrls = new ExitUrls()
	saml = new SamlSettings()
	hideFormExtendedOptions: boolean = false
	enableProctorIoIntegration: boolean = true
	enablePlagiarismDetection: boolean = true
	readSpeakerCustomerId: string = ""
	readSpeakerRegion: string = ""
	readSpeakerDocReaderId: string = ""
	readSpeakerLanguageSettings: ReadSpeakerLanguageSettings[] = [new ReadSpeakerLanguageSettings()]
	enableOffice365Integration: boolean = true
	keycode: KeycodeSettings | null = null
	enableVirtualKeyboard: boolean = true
	angoff = new AngoffSettings()
	enableLtiAdvantage: boolean = true
	regionalSettings: RegionalSettings = new RegionalSettings()

	constructor(args?: Partial<CustomerInfo>) {
		for (const argument in args) {
			this[argument] = args[argument]
		}
	}
}

type Skin = any | null

class ExitUrls {
	author: string = ""
	delivery: string = ""
}

class SamlSettings {
	enabled: boolean = false
	ssoMode: SsoMode = SsoMode.Mixed
	idpName: string = ""
}

export enum SsoMode {
	Mixed,
	Automatic,
	Enforced
}

class ReadSpeakerLanguageSettings {
	cirrusLangKey: LanguageCode = "en-GB"
	readSpeakerLangKey: string = "en_uk"
	voice: string = "Alice"
	image: string = "united-kingdom"
}

class KeycodeSettings {
	requireUsername: boolean = false
}

class AngoffSettings {
	mediumLow: number = 0
	easyLow: number = 0
	useAngoff: boolean = false
}

export class RegionalSettings {
	lang: LanguageCode = "en-GB"
	reg: string = "Europe"
	zone: string = "Europe/Oslo"
	offset: number = 120
	formats: string = "en-GB"
	stformat: string = "h:mm A"
	ltformat: string = "h:mm:ss A"
}